import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #00000065;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background: #ffffff;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 32px;

  display: flex;
  flex-direction: column;

  min-width: 688px;

  h1 {
    color: ${({ theme }) => theme.colors.blue.primary};
    font-size: 18px;
    font-weight: 500;
  }

  .details {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 23px;
    margin-top: 16px;

    h4 {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray[600]};
    }

    .detailContainer {
      display: flex;
      flex-direction: column;
      gap: 4px;
      border-bottom: 1px solid#4D4C4D;
      padding-bottom: 2px;

      h2 {
        font-size: 14px;
        line-height: 24px;
        font-weight: 600;
        color: #4d4c4d;
      }
    }

    .detailContainerDebt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #4d4c4d;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
    }
  }
`;

export const CloseButton = styled.button`
  width: 116px;
  height: 40px;
  align-self: center;
  font-weight: 800;
  margin-top: 16px;
`;
